export default "__VITE_ASSET__Bh$UCheq__"